import { render, staticRenderFns } from "./baseCollection.vue?vue&type=template&id=2032d9ed&"
import script from "@viewJs/excuseExam/baseCollection.js?vue&type=script&lang=js&"
export * from "@viewJs/excuseExam/baseCollection.js?vue&type=script&lang=js&"
import style0 from "./baseCollection.vue?vue&type=style&index=0&lang=scss&slot=scope&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports